import { render, staticRenderFns } from "./formB.vue?vue&type=template&id=f8f28e66"
import script from "./formB.vue?vue&type=script&lang=js"
export * from "./formB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports